import { REQUIRED_LOCATION_TYPE_LABELS } from '../../constants/required-location-types.js';
export const DUPLICATE_LOCATION_NAME_MESSAGE = 'Location names must be unique within the warehouse.';
/**
 * Mirrors idx_location_name_location_group_id, a case-insensitive unique index, so the form catches
 * a duplicate client-side instead of round-tripping to a constraint violation. Reports every
 * repeat after the first, leaving the original row unflagged.
 */
export function checkDuplicateLocationNames(rows) {
    const issues = [];
    const seenNames = new Set();
    for (const row of rows) {
        const normalizedName = row.name.toLocaleLowerCase();
        if (!seenNames.has(normalizedName)) {
            seenNames.add(normalizedName);
            continue;
        }
        issues.push({
            path: ['locations', row.index, 'name'],
            message: DUPLICATE_LOCATION_NAME_MESSAGE,
        });
    }
    return issues;
}
/**
 * Every type in REQUIRED_LOCATION_TYPE_LABELS needs one active row, so a warehouse cannot be
 * created unable to receive or hold stock. Reports on the array rather than a row: no single row
 * is at fault when one is missing entirely.
 */
export function checkRequiredLocationTypes(rows) {
    const issues = [];
    for (const [typeId, label] of REQUIRED_LOCATION_TYPE_LABELS) {
        if (rows.some((row) => row.typeId === typeId && row.activeFlag))
            continue;
        issues.push({
            path: ['locations'],
            message: `At least one active ${label} location is required.`,
        });
    }
    return issues;
}
//# sourceMappingURL=rules.js.map